var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_partner"},[_c('div',{staticClass:"gsjj"},[_c('p',{staticClass:"p1"},[_vm._v("合作伙伴")]),_c('div',{staticClass:"fg"})]),_c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require("../../assets/images/partner/partnerList.png"),"alt":""}})])])
}]

export { render, staticRenderFns }